export const TenantStatusName = {
	Internal: "Internal",
	NonOperating: "NonOperating",
	Operating: "Operating",
	Decommissioned: "Decommissioned",
} as const;

export type TenantStatusName = (typeof TenantStatusName)[keyof typeof TenantStatusName];

export interface TenantStatus {
	name: TenantStatusName;
	id: number;
}
